import React from 'react';

import { correctingTrailingNumbers, bemCssModules } from '@cryptoboyio/mercuryo-lab/utils';

import { getTestId } from '@utils';

import { CurrencyDisplayOptionsType, CurrencyEnum } from '@modules/global/types';

import style from './Limits.scss';

const cn = bemCssModules(style, 'Limits');
const ti = getTestId('Limits');

export type TLimits = {
  limits?: {
    [key in CurrencyEnum]?: {
      min?: string;
      max?: string;
    };
  };
  currency: CurrencyEnum;
  displayOptions?: CurrencyDisplayOptionsType;
  onClick: (value: string) => void;
  testId?: string;
  isDisplayCurrency?: boolean;
};

const Limits: CustomFC<TLimits> = props => {
  const {
    className,
    limits,
    currency,
    displayOptions,
    onClick,
    testId,
    isDisplayCurrency = false,
  } = props;

  const totalDigits = displayOptions?.[currency]?.total_digits;
  const displayDigits = displayOptions?.[currency]?.display_digits;
  const min = correctingTrailingNumbers(limits?.[currency]?.min || '', displayDigits, totalDigits);
  const max = correctingTrailingNumbers(limits?.[currency]?.max || '', displayDigits, totalDigits);

  const handleClickMin = () => {
    if (typeof onClick === 'function' && min) onClick(min);
  };

  const handleClickMax = () => {
    if (typeof onClick === 'function' && max) onClick(max);
  };

  return (
    <div className={cn(null, [className])} data-testid={ti(testId)}>
      {min && (
        <div className={cn('limit')} data-testid={ti('min')}>
          Min&nbsp;
          <button className="link" type="button" onClick={handleClickMin}>
            {min} {isDisplayCurrency && currency}
          </button>
        </div>
      )}

      {max && (
        <div className={cn('limit')} data-testid={ti('max')}>
          Max&nbsp;
          <button className="link" type="button" onClick={handleClickMax}>
            {max} {isDisplayCurrency && currency}
          </button>
        </div>
      )}
    </div>
  );
};

export default Limits;
